/**
 * ? @description : Delete Student Profile Modal
 */

// Dependencies
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

function DeleteStudentModal(props) {
  // * Redux
  const dispatch = useDispatch();

  // ! Student Id
  let studentId = props.tabledata[0];

  // ? API Call : Delete Method : Delete Student
  async function deleteProfile() {
    try {
      const options = {
        method: "delete",
        url: `student/${studentId}`,
        auth: true,
        data: null,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        props.onHide();
        // window.location.reload();
        props.onCloseCallback();
        dispatch(
          showSnackbar({
            message: response.data.message,
            severity: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Unable to delete the profile. Please try again later.",
          severity: "error",
        })
      );
    }
  }

  return (
    props.tabledata && (
      <Modal {...props} size="xl" centered aria-labelledby="delete-student">
        <Modal.Header closeButton>
          <Modal.Title id="delete-student">
            <h5>Confirmation</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h6>Are you sure you want to delete this student profile&nbsp;?</h6>

          <p
            style={{
              color: "gray",
              fontSize: "12px",
            }}
          >
            <strong style={{ color: "red" }}>Note&nbsp;:&nbsp;</strong>
            Please check mapped status of this profile before dropping it.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>
          <Button type="submit" variant="danger" onClick={deleteProfile}>
            DROP
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default DeleteStudentModal;
